import React from 'react';
import { Reveal } from './Reveal';
import { BrainCircuitIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="w-full bg-ink py-24" data-id="element-74">
      <div className="mx-auto max-w-4xl px-6" data-id="element-75">
        <Reveal data-id="element-76">
          <div className="rounded-3xl border border-electric/20 bg-indigo-deep/60 p-10 sm:p-14" data-id="element-77">
            <span className="inline-flex items-center gap-2 rounded-full bg-electric/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-electric" data-id="element-78">
              <BrainCircuitIcon className="h-4 w-4" data-id="element-79" />
              El mecanismo único
            </span>

            <h2 className="mt-6 font-display text-3xl font-semibold leading-tight text-cream sm:text-4xl" data-id="element-80">
              La clave de la libertad no está en entenderlos a ellos, sino en
              entender tu química cerebral.
            </h2>

            <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-81">
              Este eBook utiliza el{' '}
              <span className="font-semibold text-cream" data-id="element-82">
                Protocolo de Desanclaje Narrativo
              </span>
              . En lugar de analizar sus motivos, hackeamos tu sistema de
              dopamina.
            </p>

            <div className="mt-8 grid grid-cols-1 items-center gap-4 sm:grid-cols-[1fr_auto_1fr]" data-id="element-83">
              <div className="rounded-xl border border-white/10 bg-white/[0.02] p-5" data-id="element-84">
                <p className="text-xs uppercase tracking-wide text-muted" data-id="element-85">De</p>
                <p className="mt-1 font-display text-lg text-rose-glow" data-id="element-86">
                  "Esperanza de potencial"
                </p>
                <p className="mt-1 text-sm text-muted" data-id="element-87">
                  Lo que podrían haber sido.
                </p>
              </div>
              <div className="mx-auto font-display text-2xl text-electric" data-id="element-88">
                →
              </div>
              <div className="rounded-xl border border-white/10 bg-white/[0.02] p-5" data-id="element-89">
                <p className="text-xs uppercase tracking-wide text-muted" data-id="element-90">A</p>
                <p className="mt-1 font-display text-lg text-electric" data-id="element-91">
                  "Evidencia de realidad"
                </p>
                <p className="mt-1 text-sm text-muted" data-id="element-92">Lo que realmente son.</p>
              </div>
            </div>

            <p className="mt-8 text-lg leading-relaxed text-muted" data-id="element-93">
              Es un proceso quirúrgico para retirar la inversión emocional de
              una fantasía y ponerla de vuelta en{' '}
              <span className="font-semibold text-cream" data-id="element-94">tu propia vida</span>.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}